module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmtitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION TO THE WESLEYAN PAPERBACK EDITION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Part01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART I: Myth Is the Language of Historical Memory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("Chapter 1: Exposition: The Frontier as Myth and Ideology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("Chapter 2: Myth and Historical Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#ch2-1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Myth and Ideology; Whose Myth Is It?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("Chapter 3: The Frontier Myth as a Theory of Development")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part02"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART II: The Language of the Frontier Myth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter04"
    }
  }, [_vm._v("Chapter 4: Regeneration Through Violence: History as an Indian War, 1675–1820")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#ch4-1"
    }
  }, [_vm._v("The Wars of Dispossession")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter04a#ch4a-1"
    }
  }, [_vm._v("Captive and Hunter")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter04a#ch4a-2"
    }
  }, [_vm._v("The Myth and Ideology of Agrarianism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter04a#ch4a-3"
    }
  }, [_vm._v("Natural Aristocracy and the Cult of Washington")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter04a#ch4a-4"
    }
  }, [_vm._v("The Dangerous Frontiersman and the Guilt of Dispossession")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Ideology and Fiction: The Role of Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Choice of Genre")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#ch5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Leatherstocking Myth")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05a#ch5a-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cooperian Code: Race, Sex, and Class")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART III: Metropolis vs. Frontier")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Backwash of a Closing Frontier: Industrialization and the Hiatus of Expansion, 1820–1845")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facing the Desert: The Problem of Leadership in Irving’s West")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#ch6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frontier Presidents: Transformation of the Soldier Aristocrat")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06a#ch6a-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transformation of the Hunter: Jacksonian Outlaws")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Utopia/Dystopia: Plantation, Factory, and City, 1820–1845")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plantation as Utopia")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#ch7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Factory as Plantation")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#ch7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dystopia: The Last Days of Sodom")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART IV: Myth of a New Frontier: Renewal and Breakdown, 1845–1850")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: A Choice of Frontiers: Texas, Mexico, and the Far West, 1835–1850")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#ch8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Houston, Crockett, and the Return of the Frontiersman")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08a#ch8a-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Conquest of Mexico: Hunters or Conquistadores?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Myth That Wasn’t: Literary Responses to the Mexican War, 1847–1850")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#ch9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dime Novels and Romances")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#ch9-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frémont and Carson: Heyward and Hawkeye in California")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART V: The Railroad Frontier")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" 1850–1860")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Prophecy of the Iron Horse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Ideology of Race Conflict, 1848–1858")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Inversion of the Frontier Hero: William Walker and John Brown, 1855–1860")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter12#ch12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Walker: The American as Conquistador")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter12a#ch12a-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Brown: Hawkeye as Revolutionary")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Part06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART VI: Toward the Last Frontier, 1860–1876")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Regimentation and Reconstruction: The Emergence of a Managerial Ideology, 1860–1873")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter13#ch13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Manager as Soldier-Aristocrat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Reconstruction of Class and Racial Symbolism, 1865–1876")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter14#ch14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Paternalism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter14#ch14-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paupers, Proletarians, and Indians")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter14#ch14-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Peace Policy” in Practice, 1869–1875")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The New El Dorado, 1874")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15#ch15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newspapers as Mythmakers")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15#ch15-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Red Spectre of the Commune”")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15#ch15-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking for Paradise: The Frontier as Escape")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15a#ch15a-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paradise Discovered")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15a#ch15a-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philanthropy, Effeminacy, and Corporate Paternalism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15a#ch15a-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paradise Postponed")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Part07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART VII: The Boy General")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" 1839–1876")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: West Point, Wall Street, and the Wild West, 1839–1868")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: The Boy General Returns; or, Custer’s Revenge, 1868–1876")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Part08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PART VIII: The Last Stand as Ideological Object")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" 1876–1890")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: To the Last Man: Assembling the Last Stand Myth, 1876")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18#ch18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Making of an Ideological Object: Aims and Anticipations")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18#ch18-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Centennial War")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18a#ch18a-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seizing the Occasion")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18a#ch18a-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Antagonist: Sitting Bull as Metaphor")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18a#ch18a-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Sioux Civilization” in South Carolina, Myth, Anti-Myth, and No-Myth-at-All")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: The Indian War Comes Home: The Great Strike of 1877")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19#ch19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strikers as Savages")])]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19#ch19-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Myth-Ideology of a Progressive Ruling Class: The")]), _vm._v(" Nation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in 1876–1877")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Morgan’s Last Stand: Literary Mythology and the Specter of Revolution, 1876–1890")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20#ch20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boy Hero: Custer, Ragged Dick, and Tom Sawyer")])]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20#ch20-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From the Black Hills to “Buffland”: John Hay’s")]), _vm._v(" The Breadwinners")]), _vm._v("; "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20a#ch20a-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mythological Self-Criticism: Mark Twain’s Frontier")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20a#ch20a-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit of Massacre and the Instinct of Progress")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20a#ch20a-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion and Prologue: The Turn of the Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocat"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE AUTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5edd2513","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 75
// module chunks = 0